

import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import axios from "axios";

function PlatformlevelStatic() {
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editId, setEditId] = useState(null);
  const [employeesData, setEmployeesData] = useState([]);
  const [error, setError] = useState("");


  const baseUrl =
    "https://backend.maamaas.com/subscription/api/wallet/employees";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    empid: "",
  });

  const employeeFormFields = [
    { label: "Name", name: "name", type: "text" },
    { label: "Email", name: "email", type: "email" },
    { label: "Phone Number", name: "phoneNumber", type: "text" },
    { label: "Employee ID", name: "empid", type: "text" },
    // { label: "App User ID", name: "userId", type: "number" },
  ];
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [editingId, setEditingId] = useState(null);

  const handleEditRow = async (employee) => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      alert("No token found. Please log in again.");
      return;
    }

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/subscription/api/user/employee/${employee.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
        }
      );

      // console.log("✅ Get By ID Response:", response.data);

      setEditingId(employee.id);
      setEditForm(response.data); // Fill modal with API data
      setIsEditModalOpen(true);   // Open modal
    } catch (error) {
      console.error("❌ Error fetching employee by ID:", error);
      alert("Failed to fetch employee data.");
    }
  };



  const handleUpdateRow = async () => {
    const professionalUserId = localStorage.getItem("professionalUserId");
    const token = localStorage.getItem("authToken"); // ✅ Get stored token

    if (!token) {
      alert("No token found. Please log in again.");
      return;
    }

    try {
      const response = await axios.put(
        `https://backend.maamaas.com/subscription/api/user/employee/update/${editingId}?professionalUserId=${professionalUserId}`,
        editForm,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Token added here
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("✅ Update API Response:", response.data);

      setEmployeesData((prevData) =>
        prevData.map((emp) =>
          emp.id === editingId ? { ...emp, ...editForm } : emp
        )
      );

      alert(`✅ Employee updated successfully 
Id: ${editingId} 
ProfessionalId: ${professionalUserId}`);

      setIsEditModalOpen(false);
    } catch (error) {
      console.error("❌ Error updating employee:", error);
      alert("Failed to update employee.");
    }
  };


  // Fetch employees
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        // Get professionalUserId & token
        const storedUserId = localStorage.getItem("professionalUserId");
        const token = localStorage.getItem("authToken");

        if (!storedUserId) {
          setError("Professional User ID not found in localStorage");
          return;
        }

        if (!token) {
          setError("Authentication token missing");
          return;
        }

        // Correct URL using path param like Swagger
        const apiUrl = `https://backend.maamaas.com/subscription/api/user/employee/getBy/${storedUserId}`;

        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch employees: ${response.status}`);
        }

        const data = await response.json();
        console.log("✅ Employees Data:", data);

        setEmployeesData(data);
        setError("");
      } catch (err) {
        console.error("❌ Error fetching employees:", err);
        setError("Error fetching employees");
      }
    };

    fetchEmployees();
  }, []);

  // ✅ No dependency, uses value from localStorage

  const handleAddRow = () => {
    setFormData({
      name: "",
      email: "",
      phoneNumber: "",
      empid: "",
      userId: "",
      professionalUserId: "",
    });
    setEditIndex(null);
    setEditId(null);
    setIsFormModalOpen(true);
  };



  const handleDeleteRow = async (userId) => {
    const professionalUserId = localStorage.getItem("professionalUserId");
    const token = localStorage.getItem("authToken");

    if (!token) {
      alert("Auth token missing. Please login again.");
      return;
    }

    if (!professionalUserId) {
      alert("Professional User ID missing.");
      return;
    }

    if (
      !window.confirm(`Are you sure you want to delete this employee?
UserId: ${userId}
ProfessionalId: ${professionalUserId}`)
    ) {
      return;
    }

    try {
      const url =
        `https://backend.maamaas.com/subscription/api/user/employee/delete/${userId}?professionalUserId=${professionalUserId}`;

      const response = await axios.delete(url, {
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Deleted:", response.data);

      setEmployeesData((prevData) =>
        prevData.filter((emp) => String(emp.userId) !== String(userId))
      );

      alert(`Employee deleted successfully (UserId: ${userId})`);
    } catch (error) {
      console.error("Delete error:", error);
      alert("Failed to delete employee.");
    }
  };









  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleFormSubmit = async () => {
    // ✅ Get professionalUserId from localStorage
    const storedProfessionalUserId = localStorage.getItem("professionalUserId");
    const professionalUserId = storedProfessionalUserId ? Number(storedProfessionalUserId) : 0;

    const payload = {
      id: editId ? editId : 0,
      name: formData.name,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      empid: formData.empid,
      userId: Number(formData.userId),
      professionalUserId: professionalUserId, // dynamic from localStorage
    };

    console.log("📤 Sending payload:", payload);

    try {
      const token = localStorage.getItem("authToken"); // ✅ get token

      const res = await axios.post(
        `https://backend.maamaas.com/subscription/api/wallet/add/employee?professionalUserId=${professionalUserId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : undefined, // ✅ include token if available
          },
        }
      );

      setEmployeesData([...employeesData, res.data]);
      setIsFormModalOpen(false);
    } catch (err) {
      console.error("❌ API Error:", err.response?.data || err.message);
      alert("Error: " + (err.response?.data?.message || "Something went wrong"));
    }
  };




  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
        <button onClick={handleAddRow} style={addButtonStyle}>Add+</button>
      </div>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}>S.No</th>
            <th style={tableHeaderStyle}>Name</th>
            <th style={tableHeaderStyle}>Email</th>
            <th style={tableHeaderStyle}>Phone Number</th>
            <th style={tableHeaderStyle}>Employee ID</th>
            <th style={tableHeaderStyle}>App User ID</th>
            <th style={tableHeaderStyle}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {employeesData.map((item, index) => (
            <tr key={item.userId}>
              <td style={tableCellStyle}>{index + 1}</td>
              <td style={tableCellStyle}>{item.name}</td>
              <td style={tableCellStyle}>{item.email}</td>
              <td style={tableCellStyle}>{item.phoneNumber}</td>
              <td style={tableCellStyle}>{item.empid}</td>
              <td style={tableCellStyle}>{item.userId}</td>

              <td style={tableCellStyle}>
                <FaEdit
                  style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
                  onClick={() => handleEditRow(item)}
                />

                <FaTrash
                  style={{ color: "red", cursor: "pointer" }}
                  onClick={() => handleDeleteRow(item.userId)}
                />
              </td>
            </tr>
          ))}
        </tbody>

      </table>


      {isEditModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "12px",
              width: "420px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <h3
              style={{
                marginBottom: "20px",
                fontSize: "20px",
                color: "#333",
                textAlign: "center",
              }}
            >
              ✏️ Edit Employee
            </h3>

            <input
              type="text"
              placeholder="Name"
              value={editForm.name || ""}
              onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
            <input
              type="email"
              placeholder="Email"
              value={editForm.email || ""}
              onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
            <input
              type="text"
              placeholder="Phone Number"
              value={editForm.phoneNumber || ""}
              onChange={(e) => setEditForm({ ...editForm, phoneNumber: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
            <input
              type="text"
              placeholder="Employee ID"
              value={editForm.empid || ""}
              onChange={(e) => setEditForm({ ...editForm, empid: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "15px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />

            <div
              style={{
                marginTop: "15px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <button
                onClick={handleUpdateRow}
                style={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: "10px 18px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Save
              </button>
              <button
                onClick={() => setIsEditModalOpen(false)}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  padding: "10px 18px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}



      {isFormModalOpen && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3 style={{ color: "#ee6521" }}>
              {editId ? "Edit Employee" : "Add Employee"}
            </h3>

            {employeeFormFields.map((field) => (
              <div key={field.name} style={{ marginBottom: "10px" }}>
                <label htmlFor={field.name} style={{ display: "block", marginBottom: "3px" }}>
                  {field.label}:
                </label>
                <input
                  type={field.type}
                  id={field.name}
                  name={field.name}
                  value={formData[field.name]}
                  placeholder={field.label}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
            ))}

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <button onClick={handleFormSubmit} style={saveButtonStyle}>Save</button>
              <button onClick={() => setIsFormModalOpen(false)} style={closeButtonStyle}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Styles
const addButtonStyle = { padding: "8px 16px", backgroundColor: "#ee6521", color: "white", border: "none", cursor: "pointer", borderRadius: "5px", width: "100px", fontWeight: "bold" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const tableHeaderStyle = { border: "1px solid #ddd", textAlign: "center", fontWeight: "bold", backgroundColor: "#ee6521", color: "white", padding: "8px" };
const tableCellStyle = { border: "1px solid #ddd", textAlign: "center", padding: "6px" };
const modalOverlay = { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 };
const modalContent = { backgroundColor: "white", padding: "20px", borderRadius: "8px", width: "450px", maxWidth: "90%", overflowY: "auto" };
const inputStyle = { width: "100%", padding: "8px", boxSizing: "border-box", borderRadius: "4px", border: "1px solid #ccc" };
const saveButtonStyle = { backgroundColor: "#28a745", color: "white", padding: "10px 15px", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold", marginRight: "10px" };
const closeButtonStyle = { backgroundColor: "#6c757d", border: "none", color: "#fff", padding: "10px 15px", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" };

export default PlatformlevelStatic;

